import axios from 'axios'
import {
  Message,
  MessageBox
} from 'element-ui';
// const apis = {
//   production: 'http://192.168.0.57:8003', // 线上 (生成环境)
//   // production: 'http://www.pd-automotive.com/api/v1/messageboard/commit', // 线上 (生成环境)
//   development: '/api', // 本地 (开发环境)
//   // accessHomeData: 'http://www.xmyxapp.com' // 其他api
// }
//使用create方法创建axios实例
export const Service = axios.create({
  timeout: 5000, // 请求超时时间
  baseURL: process.env.NODE_ENV === 'production' ? window.ipConfig.productionBaseUrl : window.ipConfig.devBaseUrl, // 所有的请求地址前缀部分
  // withCredentials:true
  // headers: { 'content-type': 'application/json' }
  // baseURL: window.ipConfig.baseUrl
})
// 添加请求拦截器
Service.interceptors.request.use(config => {

  return config
}, error => {
  return Promise.reject(error)
})
// 添加响应拦截器
Service.interceptors.response.use(response => {

  //   const res = response.data || {};

  //   if (res.code === 200 || res.code === 501 || res.code === 502) {
  //     return Promise.resolve(res);
  //   }
  //   else if (response.status === 200 && response.data instanceof Blob) {
  //     return Promise.resolve(res);
  //   }
  //   else {
  //     return handleResponseError(res, res.message);
  //   }

  // },
  //   (error) => {
  //     const res = (error.response || {}).data || {};
  //     const message = res.code ? res.message : error.message;

  //     return handleResponseError(res, message);
  //   }
  // );

  // let loginModal = false; //重复弹出要屏蔽

  // /**
  //  * 处理响应错误
  //  * res: 服务器返回对象
  //  * message: 错误信息
  //  */
  // const handleResponseError = ((res, message) => {
  //   //需要重新登录
  //   if (res && res.code && (res.code === 401 || res.code === 403)) {
  //     if (loginModal) {
  //       return;
  //     }
  //     loginModal = true;
  //     setTimeout(() => {
  //       loginModal = false;
  //     }, 5000);


  //     let msg = res.code === 401 ? '检测到你的账号异常，请联系管理员' : '你的登录凭证已过期，可以取消继续留在该页面，或者重新登录';
  //     MessageBox.confirm(msg, '重新登录', {
  //       closeOnClickModal: false,
  //       confirmButtonText: '重新登录',
  //       cancelButtonText: '取消',
  //       type: 'warning',
  //     }).then(() => {

  //       router.replace({ name: 'login' });

  //     }).catch(() => {

  //     });

  //   }
  //   else if (res.code === 403) //无权限
  //   {
  //     Message({
  //       message: message || '无权访问',
  //       type: 'error',
  //       duration: 3 * 1000
  //     });

  //     //router.replace({name:'404'});
  //   }
  //   else {
  //     Message({
  //       message: message || '请求失败,请稍后重试',
  //       type: 'error',
  //       duration: 3 * 1000
  //     });
  //   }

  //   return Promise.reject(res);

  return response
}, error => {
  console.log(error);
  Message({
    message: '系统异常！',
    type: 'error',
    duration: 1 * 1000
  });
  // if (error.response.status == 500) {
  // }
  return Promise.reject(error)
})
export default Service